import { IDataRow } from "../types"
import { determineBPColor} from "request"

type IDataRowProps = {
  data: IDataRow;
  onClick?: () => void;
};

export const DataRow: React.FC<IDataRowProps> = ({ data, onClick }) => {
  const color = determineBPColor(data.dia, data.sys);
  return (
    <div className="bg-white dark:bg-black333 rounded-[8px]" onClick={onClick}>
      <div className="pt-[14px] px-[11px] pb-[13px] h-[110px] lg:h-[130px] lg:px-4 xl:h-[144px] xl:px-5 xl:pt-5">
        <div className="text-xs text-gray999 mb-2 lg:text-base xl:text-lg">
          {data.dateStr}
        </div>
        <div className="flex flex-row items-center justify-around">
          <div className="flex flex-col items-center mt-[7px]">
            <span
              className="font-bold text-[28px] lg:text-[30px] xl:text-[32px] xl:leading-9 leading-[32px] mb-1 font-DINCond"
              style={{ color: color }}
            >
              {data.sys}
            </span>
            <span className="text-[11px] text-gray999 leading-6 lg:text-sm lg:leading-7">
              SYS
            </span>
          </div>
          <div className="flex flex-col items-center mt-[7px]">
            <span
              className="font-bold text-[28px] lg:text-[30px] leading-[32px] xl:text-[32px] xl:leading-9 mb-1 font-DINCond"
              style={{ color: color }}
            >
              {data.dia}
            </span>
            <span className="text-[11px] text-gray999 leading-6 lg:text-sm lg:leading-7">
              DIA
            </span>
          </div>
          <div className="flex flex-col items-center mt-[7px]">
            <span className="font-bold text-[28px] leading-[32px] lg:text-[30px] xl:text-[32px] xl:leading-9 mb-1 font-DINCond text-black333 dark:text-white80">
              {data.pul}
            </span>
            <span className="text-[11px] text-gray999 leading-6 lg:text-sm lg:leading-7">
              PUL
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
